import axios from 'axios';

axios.defaults.baseURL = window.config.apiUrl;
axios.defaults.headers = {
    'X-Requested-With': 'XMLHttpRequest'
};

export default axios;
